import { FaCrosshairs, FaBolt, FaShieldAlt } from '../../../icons';

export type StanceKey = 'attack' | 'maneuver' | 'defense';

/** Same palette as the battle ActionMenu stance orbs (ActionMenu THEMES). */
export const STANCE_THEME = {
  attack: { ring: '#ff6a6a', glow: 'rgba(255,70,70,0.45)', tint: ['#ff6b6b', '#7d1111'], Icon: FaCrosshairs },
  maneuver: { ring: '#f2b84b', glow: 'rgba(240,180,74,0.40)', tint: ['#ffd166', '#7a4e0c'], Icon: FaBolt },
  defense: { ring: '#5aa0ff', glow: 'rgba(90,160,255,0.40)', tint: ['#7db4ff', '#123a78'], Icon: FaShieldAlt },
} as const satisfies Record<StanceKey, unknown>;
